var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-section',{staticClass:"mx-auto",attrs:{"flat":""}},[_c('span',{staticClass:"text-4"},[_vm._v("4")]),_c('span',{staticClass:"text-0"},[_vm._v("0")]),_c('span',{staticClass:"text-4"},[_vm._v("4")]),_c('v-card-text',{staticClass:"font-weight-bold"},[_vm._v(" THE PAGE YOU REQUESTED NOT FOUND. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }